export default "__VITE_ASSET__B0isW_gE__"